import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { PayRollBatchUploadComponent } from './pay-roll-batch-upload/pay-roll-batch-upload.component';
import { UserBatchUploadComponent } from './user-batch-upload/user-batch-upload.component';
import { VehicleBatchUploadComponent } from './vehicle-batch-upload/vehicle-batch-upload.component';

@Component({
  selector: 'app-batch-upload',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatIconModule,
    UserBatchUploadComponent,
    VehicleBatchUploadComponent,
    PayRollBatchUploadComponent,
  ],
  templateUrl: './batch-upload.page.html',
  styleUrl: './batch-upload.page.scss',
})
export class BatchUploadPage implements OnInit {
  public currentTab: string = 'user-batch-upload';

  constructor(private route: ActivatedRoute, private router: Router) {
    this.route.queryParams.subscribe((params) => {
      if (params['tab']) this.currentTab = params['tab'];
    });
  }

  public ngOnInit(): void {}

  public setTab(tab: string): void {
    this.router.navigate([], { queryParams: { tab } });
  }
}
